import { useTranslation } from 'react-i18next';

import { Header } from 'features/my-profile/components/Header';
import { ReturnFromProfileButton } from 'features/my-profile/components/ReturnFromProfileButton';

import { NotificationChannels } from './components/NotificationChannels';

export const NotificationsPage = () => {
  const { t } = useTranslation('myProfile');

  return (
    <div data-testid={'my-profile-notifications'}>
      <ReturnFromProfileButton />
      <Header data-testid={'notifications-page-header'}>{t('notifications.header')}</Header>
      <NotificationChannels />
    </div>
  );
};
